import SeeParticipants from "./SeeParticipants";
import CopySurvey from "./CopySurvey";
import { getSurveyOptions } from "@pulse/api/queryApi";
import { useParams } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import InviteMoreParticipants from "./InviteMoreParticipants";
import SendReminder from "./SendReminder";
import CompleteSurvey from "./CompleteSurvey";
import DeleteSurvey from "./DeleteButton";

export default function ActionButtons() {
    const surveyId = useParams({
        from: "/_hub/$customerId/pulse/$pulseId/surveys/$surveyId",
    }).surveyId;
    const { data: survey } = useQuery(getSurveyOptions({ surveyId: Number(surveyId) }));

    return (
        <>
            <SeeParticipants surveyId={+surveyId} />
            {survey?.status === "ACTIVE" && <SendReminder />}
            {survey?.status === "ACTIVE" && <InviteMoreParticipants surveyId={+surveyId} />}
            <CopySurvey surveyId={+surveyId} />

            {survey?.status === "ACTIVE" && <CompleteSurvey surveyId={+surveyId} />}
            {survey?.status === "COMPLETED" && <DeleteSurvey surveyId={+surveyId} />}
        </>
    );
}
